import { Upload } from "lucide-react";
import { VARIANT_LABELS } from "./constants";

export function UploadTab({
  categories, variant, setVariant, categoryId, setCategoryId,
  title, setTitle, files, setFiles, uploading, uploadProgress, onSubmit,
}) {
  return (
    <form onSubmit={onSubmit} data-testid="chart-upload-form" className="max-w-xl space-y-6">
      <div>
        <p className="mb-3 font-mono text-[10px] uppercase tracking-[0.25em] text-[#666666]">Variant</p>
        <div className="flex gap-2">
          {Object.entries(VARIANT_LABELS).map(([key, label]) => (
            <button
              key={key}
              type="button"
              data-testid={`upload-variant-${key}`}
              onClick={() => setVariant(key)}
              className={`rounded-full px-5 py-2 text-xs font-bold uppercase tracking-[0.12em] transition-colors duration-300 ${
                variant === key ? "bg-[#FFD700] text-black" : "border border-white/15 text-[#A1A1A6]"
              }`}
            >
              {label}
            </button>
          ))}
        </div>
      </div>
      <div>
        <p className="mb-3 font-mono text-[10px] uppercase tracking-[0.25em] text-[#666666]">Category</p>
        <select
          data-testid="upload-category-select"
          value={categoryId}
          onChange={(e) => setCategoryId(e.target.value)}
          className="w-full border border-white/10 bg-black px-4 py-3 text-sm text-white outline-none focus:border-[#FFD700]/60"
        >
          {(categories[variant] || []).map((c) => (
            <option key={c.id} value={c.id}>
              {c.name}
            </option>
          ))}
        </select>
      </div>
      <div>
        <p className="mb-3 font-mono text-[10px] uppercase tracking-[0.25em] text-[#666666]">Title</p>
        <input
          data-testid="upload-title-input"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder="e.g. KL 01 — 24 Jul 2026"
          className="w-full border border-white/10 bg-black px-4 py-3 text-sm text-white outline-none focus:border-[#FFD700]/60"
        />
      </div>
      <div>
        <p className="mb-3 font-mono text-[10px] uppercase tracking-[0.25em] text-[#666666]">
          Chart images (bulk supported)
        </p>
        <label
          data-testid="upload-file-drop"
          className="flex cursor-pointer flex-col items-center gap-3 border border-dashed border-white/20 px-6 py-12 text-center transition-colors duration-300 hover:border-[#FFD700]/50"
        >
          <Upload className="h-6 w-6 text-[#666666]" />
          <span className="text-sm text-[#A1A1A6]">
            {files.length ? `${files.length} image${files.length > 1 ? "s" : ""} selected` : "Click to choose images — select many at once (jpg, png, webp)"}
          </span>
          <input
            data-testid="upload-file-input"
            type="file"
            accept="image/*"
            multiple
            className="hidden"
            onChange={(e) => setFiles(Array.from(e.target.files || []))}
          />
        </label>
        {files.length > 0 && (
          <div data-testid="upload-file-list" className="mt-3 max-h-32 space-y-1 overflow-y-auto border border-white/10 p-3">
            {files.map((f, i) => (
              <p key={i} className="truncate font-mono text-[10px] uppercase tracking-[0.15em] text-[#666666]">
                {i + 1}. {f.name}
              </p>
            ))}
          </div>
        )}
      </div>
      <button
        data-testid="upload-submit-btn"
        type="submit"
        disabled={uploading}
        className="rounded-full bg-[#FFD700] px-8 py-3 text-xs font-bold uppercase tracking-[0.15em] text-black transition-transform duration-300 hover:scale-105 disabled:opacity-50"
      >
        {uploading
          ? `Uploading ${uploadProgress}...`
          : files.length > 1
            ? `Upload ${files.length} charts`
            : "Upload chart"}
      </button>
    </form>
  );
}
